export const getFanclubArticlesRoute = () => '/fanclub-articles';
